import { List, Typography, Space } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const ListFile = ({ attachments = [], onPreview }) => {
    return (
        <List
            className="mt-4"
            size="small"
            bordered
            dataSource={attachments}
            renderItem={(attachment) => (
                <List.Item>
                    <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Typography.Text>{attachment.file.name}</Typography.Text>

                        <EyeOutlined
                            style={{ cursor: "pointer", color: "#1677ff" }}
                            onClick={() => onPreview(attachment.file)}
                        />
                    </Space>
                </List.Item>
            )}
        />
    );
}

export default ListFile;
